import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/home/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: "/verify/refund",
    component: () => import('@/views/verify/RefundSecurity.vue'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    next('/');
  } else {
    next();
  }
});

export default router
